import type { IApplicationState } from '../../types/store';

export function selectedStationsSelector(state: IApplicationState): number[] {
  return state.stations.selectedStations;
}
